<template>
    <span>
        <input-radio
            v-for="option in options"
            :key="option.value"
            :class="radioClass"
            :value="isSelected(option.value)"
            :disabled="disabled"
            @update:value="$emit('update:value', option.value)"
        >
            {{ option.text }}
        </input-radio>
    </span>
</template>

<script>
import InputRadio from "./InputRadio"

export default {
    props: {
        value: String,
        options: Array,
        radioClass: [String, Array],
        disabled: Boolean,
    },

    emits: ["update:value"],

    methods: {
        isSelected(v) {
            return this.value == v
        },
    },

    components: {
        InputRadio,
    },
}
</script>
